<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'避難所情報' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>{{'追加' | translate}}</span>
    </button>

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="84" style="text-align:center"> No. </th>
      <td mat-cell *matCellDef="let shelter; let i = index" style="text-align:right"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }} </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="80" style="text-align:center">{{'編集' |
        translate}}</th>
      <td mat-cell *matCellDef="let shelter" style="text-align:center">
        <button mat-button color="primary" (click)="openEditDialog(shelter)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="50" style="text-align:center">{{'削除' |
        translate}}</th>
      <td mat-cell *matCellDef="let row" style="text-align:center">
        <mat-checkbox color="warn" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="shelter_id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="100">{{'ID' | translate}}</th>
      <td mat-cell *matCellDef="let shelter" [style.width.px]="100"> {{ shelter.shelter_id }} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'名称' | translate}}</th>
      <td mat-cell *matCellDef="let shelter"> {{ shelter.shelter_names | multiName:projectLanguages:projectBaseLang }} </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="174" style="text-align:left"> {{'更新日時' | translate}} </th>
      <td mat-cell *matCellDef="let shelter" [style.width.px]="150" style="text-align:left"> {{ shelter.updated.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>